import React from 'react';

import TableCell from '@material-ui/core/TableCell';

import { ReportCardActions } from '../../ReportCardAccess/report-card-actions.component';

interface IMultiActionReportCardButton {
  playerAssessment: IPlayerAssessment;
}

// Every row fills the report card column, even with no actions to offer, so the columns stay aligned.
export const MultiActionReportCardButton: React.FC<IMultiActionReportCardButton> = ({ playerAssessment }) => (
  <TableCell key="report-actions" padding="checkbox">
    <ReportCardActions playerAssessment={playerAssessment} />
  </TableCell>
);
